import React, { useState, useEffect } from "react";
import { Nav } from "@/components/navigation/Navbar";
import * as Text from "@/components/text";
import ReactMarkdown from "react-markdown";
import { NextSeo } from "next-seo";
import { getStrapiImage } from "@/utils/strapiFunctions";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import Image from "next/legacy/image";
import Link from "next/link";
import Script from "next/script";
import { useRouter } from "next/router";

import { localeTexts } from "@/utils/locale";

export default function Donaciones({ donaciones, locale }) {
  const router = useRouter();
  const [donacionesData, setDonacionesData] = React.useState({
    ...donaciones.attributes,
  });

  useEffect(() => {
    if (locale === "en" && donaciones.localizations?.data?.length > 0) {
      const englishData = donaciones.localizations.data.find(
        (localization) => localization.attributes.locale === "en"
      );

      if (englishData) {
        setDonacionesData({
          ...donaciones.attributes,
          ...englishData.attributes,
        });
      }
    } else {
      setDonacionesData({ ...donaciones.attributes });
    }
  }, [locale, donaciones.attributes]);

  return (
    <>
      <NextSeo
        title="Donaciones - Ambulante"
        description="Apoya a Ambulante con una donación y contribuye al cine documental."
        canonical={`https://ambulante.org/donaciones`}
        openGraph={{
          url: `https://ambulante.org/donaciones`,
          title: "Donaciones - Ambulante",
          description:
            "Apoya a Ambulante con una donación y contribuye al cine documental.",
          site_name: "Ambulante",
        }}
      />
      <Script async src="https://js.stripe.com/v3/buy-button.js" />

      <section className="amb-container">
        {donaciones.attributes?.cover_image ? (
          <div className="relative h-[500px] lg:h-[600px]">
            <div className="absolute inset-0">
              <img
                className="h-full w-full object-cover"
                src={getStrapiImage(donaciones.attributes.cover_image, "large")}
                alt="Ambulante Donaciones"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
          </div>
        ) : null}

        {donacionesData.description ? (
          <div className="lg:grid lg:grid-cols-3 lg:gap-4">
            <div className="mt-8 lg:mt-16">
              <Text.Display as="h1" size="sm">
                {locale === "en" ? "Donations" : "Donaciones"}
              </Text.Display>
              <h3 className="mt-7 text-lg uppercase tracking-wider text-gray-500 lg:mt-14">
                {localeTexts[locale]?.compartir}
              </h3>
              <div className="mt-4 flex gap-5 lg:mt-8">
                <Link
                  href="https://www.facebook.com/AmbulanteAC"
                  passHref
                  target="_blank"
                >
                  <Image
                    alt="facebook icon"
                    className="opacity-60 hover:opacity-100"
                    width={25}
                    height={25}
                    src="/next_assets/img/fb_icon.svg"
                  />
                </Link>
                <Link
                  href="https://twitter.com/Ambulante"
                  passHref
                  target="_blank"
                >
                  <Image
                    alt="twitter icon"
                    className="opacity-60 hover:opacity-100"
                    width={25}
                    height={25}
                    src="/next_assets/img/twitter_icon.svg"
                  />
                </Link>
                <Link
                  href="mailto:?subject=Algo interesante en Ambulante.org&body=https://www.ambulante.org/donaciones/"
                  passHref
                  target="_blank"
                >
                  <Image
                    alt="email icon"
                    className="opacity-60 hover:opacity-100"
                    width={25}
                    height={25}
                    src="/next_assets/img/email_icon.svg"
                  />
                </Link>
              </div>
            </div>
            <div className="mt-10 lg:col-span-2 lg:mt-40">
              <ReactMarkdown className="font-body prose text-lg prose-h2:uppercase lg:max-w-[100ch]">
                {donacionesData.description}
              </ReactMarkdown>
              <div className="mt-8 flex justify-center">
                <stripe-buy-button
                  buy-button-id="buy_btn_1T7kBBB9CeIHiZxibwRkjKj3"
                  publishable-key="pk_live_51T044WB9CeIHiZxiNQn9nwltw9IdfG4hOgClhCvH8Jzbao9duXGI9DoxOzkW7sJQdj5XzyjPmOWug0PsW6sLOwg000IzxviczY"
                />
              </div>
            </div>
          </div>
        ) : null}
      </section>
    </>
  );
}

export async function getServerSideProps(context) {
  const { locale } = context.query;
  const q = qs.stringify({
    populate: {
      localizations: "*",
      locale: "*",
      cover_image: "*",
    },
  });
  const { data } = await apiClient.get(`/api/donacion?${q}`);

  return {
    props: {
      donaciones: data.data,
      locale: locale || "es-MX",
    },
  };
}

Donaciones.getLayout = function getLayout(page) {
  return (
    <div>
      <div className="amb-container bg-white">
        <Nav theme="light" />
      </div>
      <div>{page}</div>
    </div>
  );
};
